import React, { useEffect, useRef, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SparklesIcon } from '@heroicons/react/24/outline';
import LivePointsNumber from './LivePointsNumber';

function PointsBalanceBadge({ value = 0, ariaLabel }) {
  const reducedMotion = useReducedMotion();
  const prevValueRef = useRef(value);
  const [delta, setDelta] = useState(null);

  useEffect(() => {
    const previous = prevValueRef.current;
    if (!reducedMotion) {
      if (value > previous) {
        setDelta('up');
      } else if (value < previous) {
        setDelta('down');
      }
    }
    prevValueRef.current = value;
  }, [value, reducedMotion]);

  useEffect(() => {
    if (!delta || reducedMotion) {
      return undefined;
    }

    const timer = window.setTimeout(() => setDelta(null), 700);
    return () => window.clearTimeout(timer);
  }, [delta, reducedMotion]);

  const pulseAnimation =
    delta === 'up'
      ? { scale: [1, 1.07, 1] }
      : delta === 'down'
        ? { scale: [1, 0.96, 1] }
        : { scale: 1 };

  const accentClass =
    delta === 'up'
      ? 'border-amber-300/70 bg-amber-50/90 shadow-glow  '
      : delta === 'down'
        ? 'border-secondary-300/60 bg-secondary-50/80  '
        : 'border-white/30 bg-white/40  ';

  return (
    <motion.div
      animate={pulseAnimation}
      transition={{ type: 'spring', stiffness: 380, damping: 30 }}
      aria-label={ariaLabel}
      className={`inline-flex shrink-0 items-center gap-1 rounded-xl border px-2 py-1.5 shadow-soft backdrop-blur-sm sm:gap-1.5 sm:rounded-2xl sm:px-2.5 sm:py-2 ${accentClass}`}
    >
      <motion.span
        animate={delta === 'up' ? { rotate: [0, -8, 8, 0], scale: [1, 1.15, 1] } : { rotate: 0, scale: 1 }}
        transition={{ type: 'spring', stiffness: 420, damping: 22 }}
        className="inline-flex"
      >
        <SparklesIcon className="h-3.5 w-3.5 text-amber-500 opacity-90 sm:h-4 sm:w-4" />
      </motion.span>
      <LivePointsNumber
        value={value}
        className="text-xs font-semibold tabular-nums text-amber-700  sm:text-sm"
      />
    </motion.div>
  );
}

export default PointsBalanceBadge;
